import React from "react"
import CoreZoneLayer from "@/features/gis/CoreZoneLayer.jsx"
import { zoneValueLabel } from "@/utils/zoneLabels.js"

const rows = (p) => [
  p.name && [null, p.name],
  p.peril && ["Risk", zoneValueLabel(p.peril)],
  p.status && ["Status", zoneValueLabel(p.status)],
  p.circular && ["Circular", p.circular],
  p.as_of && ["As of", p.as_of],
]

export default function Jwla(props) {
  return (
    <CoreZoneLayer
      flag="JWLA"
      path="jwla"
      title="War Risk Area (JWC)"
      style={{ fillColor: "#7b1e3c", color: "#7b1e3c", weight: 2 }}
      rows={rows}
      {...props}
    />
  )
}
